import { useState, useEffect, useCallback } from "react";
import { message } from "antd";
import IndoorPositioningAlertConfig from "../../../../api/IndoorPositioningAlertConfig";

export const useAlertConfig = (machineID, open) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [fields, setFields] = useState({});

  const load = useCallback(async () => {
    if (!machineID) return;
    setLoading(true);
    try {
      const res = await IndoorPositioningAlertConfig.GetConfig(machineID);
      if (res.code === 200) {
        setFields(res.data.config);
      } else {
        message.error(res.message || "載入警報設定失敗");
      }
    } catch {
      message.error("載入警報設定失敗");
    } finally {
      setLoading(false);
    }
  }, [machineID]);

  useEffect(() => {
    if (open) load();
  }, [open, load]);

  const setField = useCallback((key, value) => {
    setFields((prev) => ({ ...prev, [key]: value }));
  }, []);

  const save = useCallback(async () => {
    setSaving(true);
    try {
      const res = await IndoorPositioningAlertConfig.UpdateConfig(machineID, fields);
      if (res.code === 200) {
        setFields(res.data.config);
        message.success("警報設定已更新");
      } else {
        message.error(res.message || "更新失敗");
      }
    } catch {
      message.error("更新失敗");
    } finally {
      setSaving(false);
    }
  }, [machineID, fields]);

  const reset = useCallback(async () => {
    setSaving(true);
    try {
      const res = await IndoorPositioningAlertConfig.ResetConfig(machineID);
      if (res.code === 200) {
        setFields(res.data.config);
        message.success("已重置為系統預設值");
      } else {
        message.error(res.message || "重置失敗");
      }
    } catch {
      message.error("重置失敗");
    } finally {
      setSaving(false);
    }
  }, [machineID]);

  return { loading, saving, fields, setField, save, reset };
};
